const METHODS = [
  { label: "UPI", accent: true },
  { label: "GPay" },
  { label: "PhonePe" },
  { label: "Paytm" },
  { label: "Visa" },
  { label: "Mastercard" },
  { label: "RuPay" },
  { label: "Net Banking" },
];

export default function PaymentBadges({ compact = false, onSelect = null }) {
  const clickable = typeof onSelect === "function";
  return (
    <div className={compact ? "" : "border border-[#e5e5e5] p-5"}>
      {!compact && (
        <div className="label-eyebrow mb-4">
          {clickable ? "Pay with" : "We accept"}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {METHODS.map((m) => {
          const cls = `text-[10px] uppercase tracking-widest px-3 py-2 border ${
            m.accent
              ? "border-[#111] bg-[#111] text-white"
              : "border-[#e5e5e5] text-[#111] bg-white"
          } ${clickable ? "cursor-pointer hover:border-[#111] hover:bg-[#111] hover:text-white transition-colors" : ""}`;
          const testid = `payment-badge-${m.label.toLowerCase().replace(/\s+/g, "-")}`;
          if (clickable) {
            return (
              <button
                type="button"
                key={m.label}
                onClick={() => onSelect(m.label)}
                className={cls}
                data-testid={testid}
              >
                {m.label}
              </button>
            );
          }
          return (
            <span key={m.label} className={cls} data-testid={testid}>
              {m.label}
            </span>
          );
        })}
      </div>
      {clickable && (
        <p className="text-xs text-[#666] mt-3">
          Click any method above to proceed. You'll pick the exact option (e.g. GPay QR) in the
          Razorpay checkout that opens.
        </p>
      )}
    </div>
  );
}
